import { render, staticRenderFns } from "./scene10.vue?vue&type=template&id=7ed78893&scoped=true&"
import script from "./scene10.vue?vue&type=script&lang=ts&"
export * from "./scene10.vue?vue&type=script&lang=ts&"
import style0 from "./scene10.vue?vue&type=style&index=0&id=7ed78893&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed78893",
  null
  
)

export default component.exports